import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";

import { DatePickerDialog as DatePicker, DayPicker } from "../Utilities/DatePicker";

// Date Picker
type DatePickerProps = {
  show: boolean;
  onHide: () => void;
  onSubmit: (e: any) => void;
  [x: string]: any;
};
export default function DatePickerModal(props: DatePickerProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={props.show} onClose={props.onHide} fullWidth maxWidth="sm">
      <DialogTitle
        style={{
          color: "#525252",
          marginBottom: -25,
        }}
      >
        {t("Pick date")}
      </DialogTitle>
      <hr />
      <form onSubmit={props.onSubmit}>
        <DialogContent style={{ padding: "12px 24px" }}>
          <DatePicker startDate={props.startDate} endDate={props.endDate} />
        </DialogContent>
        <hr />
        <DialogActions style={{ padding: "10px 25px", marginTop: -15 }}>
          <Button
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "#333333",
              textTransform: "capitalize",
            }}
            onClick={props.onHide}
          >
            {t("Cancel")}
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{
              backgroundColor: "var(--text-primary)",
              color: "#ffffff",
              textTransform: "capitalize",
            }}
          >
            {t("Done")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
export function DayPickerModal(props: DatePickerProps) {
  const { t } = useTranslation();
  return (
    <Modal show={props.show} onHide={props.onHide} centered={true}>
      <Modal.Header>
        <Modal.Title>{t("Day Picker")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={props.onSubmit}>
          <DayPicker date={props.date} />
          <div className="button-group d-flex justify-content-center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "var(--text-primary)",
                color: "#ffffff",
                textTransform: "capitalize",
              }}
            >
              {t("Done")}
            </Button>
            <Button
              type="reset"
              variant="contained"
              color="primary"
              style={{
                backgroundColor: "#333333",
                textTransform: "capitalize",
              }}
              onClick={props.onHide}
            >
              {t("Cancel")}
            </Button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
